// extracted by mini-css-extract-plugin
module.exports = {"currency":"string_utils_currency__13FhF"};